import { render, staticRenderFns } from "./AuthorStandardsMenu.vue?vue&type=template&id=0f0ae0b6&scoped=true"
import script from "./AuthorStandardsMenu.vue?vue&type=script&lang=ts"
export * from "./AuthorStandardsMenu.vue?vue&type=script&lang=ts"
import style0 from "./AuthorStandardsMenu.vue?vue&type=style&index=0&id=0f0ae0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0ae0b6",
  null
  
)

export default component.exports